export { practicesReactFeature, PracticesReactFeature as default } from './PracticesReactFeature'
